import { useTranslation } from 'next-i18next';

const useGetRoomsNumberItems = (type: 'bedRooms' | 'rooms') => {
    const numberItems = 5;
    const { t } = useTranslation(['ad']);

    return Array.from({ length: numberItems }, (_, i) => {
        let label = String(i + 1);
        if (i === numberItems - 1) {
            label = `${i + 1}+`;
        }
        if (type === 'rooms' && i === 0) {
            label = String(t('ad:studio'));
        }
        return {
            label,
            value: i + 1,
        };
    });
};

export default useGetRoomsNumberItems;
